// modifyNamedWindowBody — VQE-Edit edit-action: replace a `WINDOW w AS (…)`
// definition's inner body via SR-Edit's `modify-named-window-body` op. The
// applicator replaces the bytes BETWEEN the parens, so `newBodyText` must NOT
// include the surrounding parentheses (it is the serialized OverBodySpec, e.g.
// `PARTITION BY a ORDER BY b`).
//
// Task: VQE Polish §4b-ii — named-window card real editing (WindowSpecEditor reuse).

import { commitEdit, type CommitEditCtx } from '../commitEdit';

export async function modifyNamedWindowBody(
  index: number,
  newBodyText: string,
  ctx: CommitEditCtx,
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`modifyNamedWindowBody: index must be a non-negative integer (got ${index})`);
  }
  // An empty body is valid (`WINDOW w AS ()`); trim only so the parens hug the spec.
  await commitEdit({ op: 'modify-named-window-body', index, newBodyText: newBodyText.trim() }, ctx);
}
